import { render, staticRenderFns } from "./SystemMessageTip.vue?vue&type=template&id=0475bc40&scoped=true&"
import script from "./SystemMessageTip.vue?vue&type=script&lang=ts&"
export * from "./SystemMessageTip.vue?vue&type=script&lang=ts&"
import style0 from "./SystemMessageTip.vue?vue&type=style&index=0&id=0475bc40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0475bc40",
  null
  
)

export default component.exports